@use "variables" as *;

.item {
  aspect-ratio: 3 / 3.33;
  display: flex;
}

.skeleton {
  width: 100%;
  height: 100% !important;
  border-radius: 8px;
  min-width: 164px;
}

.threeDimensionalPanel {
  display: flex;
  width: 100%;
  height: 460px;
  align-items: center;
  justify-content: center;
  margin-bottom: $spacing-m;
}
